<div class="imagesliderbounds clicable" [class.radiustopleft]="radiustopleft()"
    [class.radiustopright]="radiustopright()" [class.radiusbottomleft]="radiusbottomleft()"
    [class.radiusbottomright]="radiusbottomright()" (click)="sendClick();">
    @if(_data?.length > 0 && currentimgposition > 0) {
    <button aria-label="left-arrow" class="left-arrow arrow" mat-button (click)="previus($event);">
        <mat-icon class="arowico">arrow_back_ios</mat-icon>
    </button>
    }
    @if(_data?.length > 0 && currentimgposition < _data?.length - 1) { <button mat-button aria-label="right-arrow"
        class="right-arrow arrow" (click)="next($event);">
        <mat-icon class="arowico">arrow_forward_ios</mat-icon>
        </button>
        }
        @if(showcounter() && _data?.length > 1) {
        <div class="cc8">
            <div class="cc9">
                <span multilang>{{currentimgposition + 1}}/{{_data?.length}}</span>
            </div>
        </div>
        }
        <div class="imageslidercontent" style="border-radius:0.5rem;" (scroll)="scrolling()" #imageslidercontent>
            @if(showImages()) {
            @for(img of _data; let k=$index; track k) {
            <div class="img" style="border-radius:0.5rem;"
                [class]=" desktopTemplate !=='xs' ? 'wideimagesliderimagecontent' : 'imagesliderimagecontent'">
                @if(k <= currentimgposition + 1 && k>= currentimgposition - 1) {
                    @if(img?.length > 0) {
                    <img class=" imagezoom" loading="lazy" [src]="img | cacheResource" style="border-radius:0.5rem;"
                        (error)="handelError(k)" alt="image">
                    }
                    }
            </div>
            }
            }
        </div>
</div>

<ng-template #emptybild>
    @if(showImages()) {
    <img src="../../../assets/images/empty.jpg" loading="lazy" class="img" [class.radiustopleft]="radiustopleft()"
        [class.radiustopright]="radiustopright()" [class.radiusbottomleft]="radiusbottomleft()"
        [class.radiusbottomright]="radiusbottomright()" alt="image">
    }
</ng-template>